var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"800px"},attrs:{"src":"https://www.luckyair.net//pssplus/frontend/8l/delay/delay_todelay.action?weight=100","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }